import {
    CREATE_PLAYERS_ERROR,
    CREATE_PLAYERS_LOADING,
    CREATE_PLAYERS_SUCCESS,
    EDIT_PLAYERS_LOADING,
    EDIT_PLAYERS_SUCCESS,
    EDIT_PLAYERS_ERROR,
    DELETE_TEAMS_ERROR,
    DELETE_PLAYERS_LOADING,
    DELETE_PLAYERS_ERROR, DELETE_PLAYERS_SUCCESS,
} from "../../../constant/actionTypes";
import {apiDelete, apiPost, apiPut} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {toast} from "react-toastify";

export const createNewPlayer = (data) => (dispatch) => {
  dispatch({ type: CREATE_PLAYERS_LOADING });
  apiPost(
    `${ApiEndpoints.player.base}`,
    data,
    (response) => {
      if (response.error === true) {
        dispatch({ type: CREATE_PLAYERS_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_PLAYERS_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: CREATE_PLAYERS_ERROR, response: error });
    }
  );
};

export const editPlayer = (id, data) => (dispatch) => {
  dispatch({ type: EDIT_PLAYERS_LOADING });
  apiPut(
    `${ApiEndpoints.course.base}${ApiEndpoints.course.update}${id}`,
    data,
    (response) => {
      if (response.error === true) {
        dispatch({ type: EDIT_PLAYERS_ERROR, response: response.message });
      } else {
        dispatch({ type: EDIT_PLAYERS_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: EDIT_PLAYERS_ERROR, response: error });
    }
  );
};

export const deletePlayer = (id) => (dispatch) => {
    dispatch({type: DELETE_PLAYERS_LOADING});
    apiDelete(
        `${ApiEndpoints.allPlayers.delete}${id}`,
        (response) => {
            if (response.error === true) {
                dispatch({type: DELETE_PLAYERS_ERROR, response: response.message});
                toast.error("Player delete error");
            } else {
                dispatch({type: DELETE_PLAYERS_SUCCESS, response: response});
                toast.success("Player deleted");
            }
        },
        (error) => {
            dispatch({type: DELETE_TEAMS_ERROR, response: error});
            toast.error("Player delete error");
        }
    );
};